export default __webpack_public_path__ + "static/media/search-icon.29956de3.svg";